import { ContentNode, ContentNodeUtils } from '@helo/cms'
import { useEffect } from 'react'

import { useAppStore } from '../../store/appStore/appStore'
import { createWidget } from '../widget-utils'

export interface BrowserTitleReporterProps {
  contentNode?: ContentNode
  isLoading?: boolean
}

/**
 * Reports a scalar `contentNode` into the browser title slice as the detail
 * page’s primary entity display string. Prefer
 * `ViewConfig.state.browserTabTitleEntityContentNode` on the view so that string
 * resolves without an extra widget; use this for one-off or dynamic cases.
 */
export const BrowserTitleReporter = ({
  contentNode,
  isLoading,
}: BrowserTitleReporterProps) => {
  useEffect(() => {
    if (isLoading) return

    const raw = contentNode ? ContentNodeUtils.asText()(contentNode) : ''
    const trimmed = raw?.trim()
    const id =
      trimmed && trimmed !== '-' && trimmed !== 'Multiple' ? trimmed : null

    useAppStore.getState().browserDocumentTitle.updateTitle({
      detailEntityDisplay: id,
    })

    return () => {
      useAppStore.getState().browserDocumentTitle.updateTitle({
        detailEntityDisplay: null,
      })
    }
  }, [contentNode, isLoading])

  return null
}

export const BrowserTitleReporterDefinition = createWidget(
  BrowserTitleReporter,
  {
    type: 'BrowserTitleReporter',
    manualQuery: true,
  },
)
